import { useMemo } from 'react';
import { NodeType } from '@/enums/node-type.enum';
import { AiModelData } from '@/types/nodes/model';
import { useFlowView } from '../FlowContext';
import type { Node } from '@/types/node';

export const usePropertiesDrawer = (
  selectedNodes: Node[],
): {
  nodesForPropertiesDrawer: Node[];
} => {
  const flowView = useFlowView();
  return useMemo(() => {
    const selectedNodeIds = new Set(selectedNodes.map((n) => n.id));
    const selectedGroupNodeIds = new Set(selectedNodes.filter((n) => n.type === NodeType.CustomGroup).map((n) => n.id));
    const extendedSelectedNodes =
      selectedGroupNodeIds.size > 0
        ? flowView
            .getNodes()
            .filter((n) => n.parentId && selectedGroupNodeIds.has(n.parentId) && !selectedNodeIds.has(n.id))
        : [];

    const allSelectedNodes = [...selectedNodes, ...extendedSelectedNodes].filter((n) => {
      const kind = n.type === 'custommodelV2' ? (n.data as AiModelData)?.kind : undefined;
      const isEmptyImportModelNode =
        (n.type === NodeType.WildcardV2 && !n.data.version) ||
        (kind?.type === 'wildcard' && kind.model.type === 'none');
      return !isEmptyImportModelNode;
    });

    return {
      nodesForPropertiesDrawer: allSelectedNodes,
    };
  }, [selectedNodes, flowView]);
};
